import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useRecoilValue } from "recoil";
import Template from "../../components/Layout/Template";
import Candidate from "../../pages/Admin/Candidate/Candidate";
import DashboardAdmin from "../../pages/Admin/Dashboard/Dashboard";
import Clinic from "../../pages/Admin/DataManagement/Clinic";
import Division from "../../pages/Admin/DataManagement/Division/Division";
import Information from "../../pages/Admin/DataManagement/Information/Information";
import OfficeLocation from "../../pages/Admin/DataManagement/OfficeLocation";
import TestimonialManagement from "../../pages/Admin/DataManagement/Testimonial/TestimonialManagement";
import { userDataSelector } from "../../shared/globalStates";
import DemographyManagement from "../../pages/Admin/DataManagement/Demography/DemographyManagement";

function RouterAdmin() {
  return (
    <React.Fragment>
      <Switch>
        <Template>
          <PrivateRoute path="/Admin" exact>
            <DashboardAdmin />
          </PrivateRoute>
          <PrivateRoute path="/Admin/division">
            <Division />
          </PrivateRoute>
          <PrivateRoute path="/Admin/clinic">
            <Clinic />
          </PrivateRoute>
          <PrivateRoute path="/Admin/officelocation">
            <OfficeLocation />
          </PrivateRoute>
          <PrivateRoute path="/Admin/candidates/:opportunityID">
            <Candidate />
          </PrivateRoute>
          <PrivateRoute path="/Admin/information">
            <Information />
          </PrivateRoute>
          <PrivateRoute path="/Admin/testimonial">
            <TestimonialManagement />
          </PrivateRoute>
          <PrivateRoute path="/Admin/demography">
            <DemographyManagement />
          </PrivateRoute>
        </Template>
      </Switch>
    </React.Fragment>
  );
}

function PrivateRoute({ children, ...rest }) {
  const authLogin = useRecoilValue(userDataSelector);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        return authLogin?.is_admin === true ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/Admin/login",
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
}

export default RouterAdmin;
